import { Hero } from "@/components/home/Hero";
import { ClientLogos } from "@/components/home/ClientLogos";
import { Bento } from "@/components/home/Bento";
import { Steps } from "@/components/home/Steps";
import { Welcome, Merchants, Support, Human, Spotlight } from "@/components/home/SolaSections";
import { Marquee } from "@/components/site/Marquee";
import { Testimonials } from "@/components/site/Testimonials";
import { FAQ } from "@/components/site/FAQ";
import { CTA } from "@/components/site/CTA";
import { BookCall } from "@/components/site/BookCall";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <ClientLogos />
      <Marquee />
      <Welcome />
      <Merchants />
      <Support />
      <Human />
      <Spotlight />
      <Bento />
      <Steps />
      <Testimonials />
      <BookCall />
      <FAQ />
      <CTA />
    </div>
  );
}
